var _excluded = ["offset"];
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import unraw from 'unraw';
import { compileMessage } from '@lingui/message-utils/compileMessage';
var isString = function isString(s) {
  return typeof s === "string";
};
var isFunction = function isFunction(f) {
  return typeof f === "function";
};
var cache = /* @__PURE__ */new Map();
function normalizeLocales(locales) {
  var out = Array.isArray(locales) ? locales : [locales];
  return [].concat(_toConsumableArray(out), ["en"]);
}
function _date(locales, value, format) {
  var _locales = normalizeLocales(locales);
  var formatter = getMemoized(function () {
    return cacheKey("date", _locales, format);
  }, function () {
    return new Intl.DateTimeFormat(_locales, format);
  });
  return formatter.format(isString(value) ? new Date(value) : value);
}
function _number(locales, value, format) {
  var _locales = normalizeLocales(locales);
  var formatter = getMemoized(function () {
    return cacheKey("number", _locales, format);
  }, function () {
    return new Intl.NumberFormat(_locales, format);
  });
  return formatter.format(value);
}
function _plural(locales, ordinal, value, _ref) {
  var _ref2, _rules$value;
  var _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    rules = _objectWithoutProperties(_ref, _excluded);
  var _locales = normalizeLocales(locales);
  var plurals = ordinal ? getMemoized(function () {
    return cacheKey("plural-ordinal", _locales);
  }, function () {
    return new Intl.PluralRules(_locales, {
      type: "ordinal"
    });
  }) : getMemoized(function () {
    return cacheKey("plural-cardinal", _locales);
  }, function () {
    return new Intl.PluralRules(_locales, {
      type: "cardinal"
    });
  });
  return (_ref2 = (_rules$value = rules[value]) !== null && _rules$value !== void 0 ? _rules$value : rules[plurals.select(value - offset)]) !== null && _ref2 !== void 0 ? _ref2 : rules.other;
}
function getMemoized(getKey, construct) {
  var key = getKey();
  var formatter = cache.get(key);
  if (!formatter) {
    formatter = construct();
    cache.set(key, formatter);
  }
  return formatter;
}
function cacheKey(type, locales, options) {
  var localeKey = locales.join("-");
  return "".concat(type, "-").concat(localeKey, "-").concat(JSON.stringify(options));
}
var formats = {
  __proto__: null,
  date: _date,
  number: _number,
  plural: _plural
};
var UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;
var getDefaultFormats = function getDefaultFormats(locale, locales) {
  var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  locales = locales || locale;
  var style = function style(format) {
    return isString(format) ? formats[format] || {
      style: format
    } : format;
  };
  var replaceOctothorpe = function replaceOctothorpe(value, message) {
    var numberFormat = Object.keys(formats).length ? style("number") : {};
    var valueStr = _number(locales, value, numberFormat);
    return message.replace("#", valueStr);
  };
  return {
    plural: function plural(value, cases) {
      var _cases$offset = cases.offset,
        offset = _cases$offset === void 0 ? 0 : _cases$offset;
      var message = _plural(locales, false, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    selectordinal: function selectordinal(value, cases) {
      var _cases$offset2 = cases.offset,
        offset = _cases$offset2 === void 0 ? 0 : _cases$offset2;
      var message = _plural(locales, true, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    select: function select(value, rules) {
      var _rules$value2;
      return (_rules$value2 = rules[value]) !== null && _rules$value2 !== void 0 ? _rules$value2 : rules.other;
    },
    number: function number(value, format) {
      return _number(locales, value, style(format));
    },
    date: function date(value, format) {
      return _date(locales, value, style(format));
    },
    undefined: function undefined(value) {
      return value;
    }
  };
};
function interpolate(translation, locale, locales) {
  return function (values) {
    var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formatters = getDefaultFormats(locale, locales, formats);
    var formatMessage = function formatMessage(message) {
      if (!Array.isArray(message)) return message;
      return message.reduce(function (message2, token) {
        if (isString(token)) return message2 + token;
        var _token = _slicedToArray(token, 3),
          name = _token[0],
          type = _token[1],
          format = _token[2];
        var interpolatedFormat = {};
        if (format != null && !isString(format)) {
          Object.keys(format).forEach(function (key) {
            interpolatedFormat[key] = formatMessage(format[key]);
          });
        } else {
          interpolatedFormat = format;
        }
        var value = formatters[type](values[name], interpolatedFormat);
        if (value == null) return message2;
        return message2 + value;
      }, "");
    };
    var result = formatMessage(translation);
    if (isString(result) && UNICODE_REGEX.test(result)) {
      return unraw(result.trim());
    }
    if (isString(result)) return result.trim();
    return result;
  };
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$1 = function __publicField$1(obj, key, value) {
  __defNormalProp$1(obj, _typeof(key) !== "symbol" ? key + "" : key, value);
  return value;
};
var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    __publicField$1(this, "_events", {});
  }
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, listener) {
      var _this = this;
      if (!this._hasEvent(event)) this._events[event] = [];
      this._events[event].push(listener);
      return function () {
        return _this.removeListener(event, listener);
      };
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      if (!this._hasEvent(event)) return;
      var index = this._events[event].indexOf(listener);
      if (~index) this._events[event].splice(index, 1);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this2 = this;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (!this._hasEvent(event)) return;
      this._events[event].map(function (listener) {
        return listener.apply(_this2, args);
      });
    }
  }, {
    key: "_hasEvent",
    value: function _hasEvent(event) {
      return Array.isArray(this._events[event]);
    }
  }]);
  return EventEmitter;
}();
var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, _typeof(key) !== "symbol" ? key + "" : key, value);
  return value;
};
var I18n = /*#__PURE__*/function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);
  var _super = _createSuper(I18n);
  function I18n(params) {
    var _this3;
    _classCallCheck(this, I18n);
    _this3 = _super.call(this);
    __publicField(_assertThisInitialized(_this3), "_locale");
    __publicField(_assertThisInitialized(_this3), "_locales");
    __publicField(_assertThisInitialized(_this3), "_localeData");
    __publicField(_assertThisInitialized(_this3), "_messages");
    __publicField(_assertThisInitialized(_this3), "_missing");
    /**
     * Alias for {@see I18n._}
     */
    __publicField(_assertThisInitialized(_this3), "t", _this3._.bind(_assertThisInitialized(_this3)));
    _this3._messages = {};
    _this3._localeData = {};
    if (params.missing != null) _this3._missing = params.missing;
    if (params.messages != null) _this3.load(params.messages);
    if (params.localeData != null) _this3.loadLocaleData(params.localeData);
    if (params.locale != null || params.locales != null) {
      _this3.activate(params.locale, params.locales);
    }
    return _this3;
  }
  _createClass(I18n, [{
    key: "locale",
    get: function get() {
      return this._locale;
    }
  }, {
    key: "locales",
    get: function get() {
      return this._locales;
    }
  }, {
    key: "messages",
    get: function get() {
      var _this$_messages$this$;
      return (_this$_messages$this$ = this._messages[this._locale]) !== null && _this$_messages$this$ !== void 0 ? _this$_messages$this$ : {};
    }
    /**
     * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
     */
  }, {
    key: "localeData",
    get: function get() {
      var _this$_localeData$thi;
      return (_this$_localeData$thi = this._localeData[this._locale]) !== null && _this$_localeData$thi !== void 0 ? _this$_localeData$thi : {};
    }
  }, {
    key: "_loadLocaleData",
    value: function _loadLocaleData(locale, localeData) {
      if (this._localeData[locale] == null) {
        this._localeData[locale] = localeData;
      } else {
        Object.assign(this._localeData[locale], localeData);
      }
    }
    /**
     * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
     */
  }, {
    key: "loadLocaleData",
    value: function loadLocaleData(localeOrAllData, localeData) {
      var _this4 = this;
      if (localeData != null) {
        this._loadLocaleData(localeOrAllData, localeData);
      } else {
        Object.keys(localeOrAllData).forEach(function (locale) {
          return _this4._loadLocaleData(locale, localeOrAllData[locale]);
        });
      }
      this.emit("change");
    }
  }, {
    key: "_load",
    value: function _load(locale, messages) {
      if (this._messages[locale] == null) {
        this._messages[locale] = messages;
      } else {
        Object.assign(this._messages[locale], messages);
      }
    }
  }, {
    key: "load",
    value: function load(localeOrMessages, messages) {
      var _this5 = this;
      if (messages != null) {
        this._load(localeOrMessages, messages);
      } else {
        Object.keys(localeOrMessages).forEach(function (locale) {
          return _this5._load(locale, localeOrMessages[locale]);
        });
      }
      this.emit("change");
    }
    /**
     * @param options {@link LoadAndActivateOptions}
     */
  }, {
    key: "loadAndActivate",
    value: function loadAndActivate(_ref3) {
      var locale = _ref3.locale,
        locales = _ref3.locales,
        messages = _ref3.messages;
      this._locale = locale;
      this._locales = locales || void 0;
      this._messages[this._locale] = messages;
      this.emit("change");
    }
  }, {
    key: "activate",
    value: function activate(locale, locales) {
      if (process.env.NODE_ENV !== "production") {
        if (!this._messages[locale]) {
          console.warn("Messages for locale \"".concat(locale, "\" not loaded."));
        }
      }
      this._locale = locale;
      this._locales = locales;
      this.emit("change");
    }
  }, {
    key: "_",
    value: function _(id) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        message = _ref4.message,
        formats = _ref4.formats;
      if (!isString(id)) {
        values = id.values || values;
        message = id.message;
        id = id.id;
      }
      var messageMissing = !this.messages[id];
      var missing = this._missing;
      if (missing && messageMissing) {
        return isFunction(missing) ? missing(this._locale, id) : missing;
      }
      if (messageMissing) {
        this.emit("missing", {
          id: id,
          locale: this._locale
        });
      }
      var translation = this.messages[id] || message || id;
      if (process.env.NODE_ENV !== "production") {
        translation = isString(translation) ? compileMessage(translation) : translation;
      }
      if (isString(translation) && UNICODE_REGEX.test(translation)) return JSON.parse("\"".concat(translation, "\""));
      if (isString(translation)) return translation;
      return interpolate(translation, this._locale, this._locales)(values, formats);
    }
  }, {
    key: "date",
    value: function date(value, format) {
      return _date(this._locales || this._locale, value, format);
    }
  }, {
    key: "number",
    value: function number(value, format) {
      return _number(this._locales || this._locale, value, format);
    }
  }]);
  return I18n;
}(EventEmitter);
function setupI18n() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new I18n(params);
}
var i18n = setupI18n();
export { I18n, formats, i18n, setupI18n };